export const MY_SCHEDULE_ACTIONS = {
  GET_MY_SCHEDULE_SUCCESS: "GET_MY_SCHEDULE_SUCCESS",
  GET_MY_SCHEDULE_FAILED: "GET_MY_SCHEDULE_FAILED",
  CLEAR_MY_SCHEDULE_STORE: "CLEAR_MY_SCHEDULE_STORE",
  GET_SCHEDULE_DETAILS: "GET_SCHEDULE_DETAILS",
  GET_BED_LIST: "GET_BED_LIST",
  GET_POST_OT_AREAS: "GET_POST_OT_AREAS",
};
